(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('product-whatsapp')) return;

    class ProductWhatsapp extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelector('[data-wa-open]').addEventListener('click', () => this.dialog.showModal());
        this.querySelector('[data-wa-close]').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-wa-submit]').addEventListener('click', () => this.submit());
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        // Evita que Enter envíe el formulario de la página
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
            e.preventDefault();
            this.submit();
          }
        });
      }

      // Lee la variante y la cantidad que el cliente tiene seleccionadas en este momento
      getSelection(product) {
        const scope = this.closest('.shopify-section') || document;
        const variantInput = scope.querySelector('product-form-component input[name="id"]');
        const qtyInput = scope.querySelector('product-form-component [name="quantity"]');
        const variantId = variantInput ? Number(variantInput.value) : null;
        const variant = product.variants.find((v) => v.id === variantId) || product.variants[0];
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        return { variant, quantity };
      }

      buildMessage() {
        const product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        const { variant, quantity } = this.getSelection(product);
        const fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        });
        const intro = this.dataset.message || 'Hola, quiero realizar un pedido de este producto:';
        const variantName = variant.title && variant.title !== 'Default Title' ? ` (${variant.title})` : '';
        const link = `${window.location.origin}${product.url || window.location.pathname}`;
        const total = fmt.format((variant.price * quantity) / 100);

        const customer = [...this.querySelectorAll('[data-field]')]
          .map((f) => [f.dataset.label, f.value.trim()])
          .filter(([, value]) => value)
          .map(([label, value]) => `${label}: ${value}`);

        return [
          intro,
          '',
          `*${product.title}*${variantName}`,
          `Cantidad: ${quantity}`,
          `Precio unitario: ${fmt.format(variant.price / 100)}`,
          link,
          '',
          `*Total: ${total}*`,
          '',
          '*Datos del cliente*',
          customer.join('\n'),
        ].join('\n');
      }

      submit() {
        const fields = [...this.querySelectorAll('[data-field]')];
        for (const field of fields) {
          if (!field.reportValidity()) return;
        }
        const number = (this.dataset.number || '').replace(/\D/g, '');
        const url = `https://wa.me/${number}?text=${encodeURIComponent(this.buildMessage())}`;
        const win = window.open(url, '_blank');
        if (!win) window.location.href = url;
        this.dialog.close();
      }
    }
    customElements.define('product-whatsapp', ProductWhatsapp);
  })();
  } catch(e) { console.error(e); }
})();

})();
